import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import MessageListPanel from "./MessageListPanel";
import OpenMessageCard from "./OpenMessageCard";

const MessagesBoard = ({ 
  messages, 
  starredMessages, 
  toggleStar, 
  onSelectMessage = () => {},
}) => {
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (messages?.length && !selectedId) {
      setSelectedId(messages[0].tic_id);
    }
  }, [messages, selectedId]);

  const selectedMessage =
    messages?.find((m) => m.tic_id === selectedId);

  const handleSelect = (message) => {
    setSelectedId(message.tic_id);
    onSelectMessage(message);
};

  return (
    <div className="flex flex-col space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="col-span-1">
          <MessageListPanel
            messages={messages}
            selectedMessage={selectedMessage}
            onSelect={handleSelect}
            starredMessages={starredMessages}
            onToggleStar={toggleStar}
          />
        </div>

        <div className="col-span-2 space-y-6">
          {selectedMessage && (
            <OpenMessageCard
              message={selectedMessage}
              isStarred={starredMessages[selectedMessage.tic_id]}
              onToggleStar={() => toggleStar(selectedMessage.tic_id)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(MessagesBoard);